export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Participate in team standups and share product updates', frequency: 'Daily at 9 AM' },
      { name: 'Sprint Planning', description: 'Lead sprint planning sessions with development teams', process: 'Define user stories and acceptance criteria' },
      { name: 'Stakeholder Updates', description: 'Regular updates to stakeholders on product progress', frequency: 'Weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Cross-team communication', channels: ['#product-team', '#engineering', '#design'] },
      { name: 'JIRA', purpose: 'Product backlog management', access: 'Product owner permissions' },
      { name: 'Confluence', purpose: 'Product documentation', permissions: 'Editor access to product spaces' }
    ],
    processes: [
      { name: 'Feature Development', steps: ['Gather requirements', 'Write user stories', 'Define acceptance criteria', 'Prioritize backlog'] },
      { name: 'User Feedback Collection', steps: ['Conduct user interviews', 'Analyze feedback', 'Document insights', 'Share with team'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Product Strategy Sessions', description: 'Lead product strategy discussions and roadmap planning', frequency: 'Bi-weekly' },
      { name: 'Cross-functional Coordination', description: 'Coordinate between engineering, design, and marketing teams', commitment: 'Daily collaboration' },
      { name: 'Market Research', description: 'Conduct competitive analysis and market research', scope: 'Product positioning and strategy' }
    ],
    tools: [
      { name: 'ProductBoard', purpose: 'Product roadmap and feature prioritization', access: 'Admin permissions' },
      { name: 'Amplitude', purpose: 'Product analytics and user behavior analysis', access: 'Advanced analytics access' },
      { name: 'Miro', purpose: 'Collaborative planning and ideation', permissions: 'Board creation and management' }
    ],
    processes: [
      { name: 'Go-to-Market Planning', steps: ['Define target market', 'Create positioning strategy', 'Plan launch activities', 'Coordinate with marketing'] },
      { name: 'Product Performance Analysis', steps: ['Define KPIs', 'Set up tracking', 'Analyze metrics', 'Report insights'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Product Vision and Strategy', description: 'Define long-term product vision and strategic direction', responsibility: 'Product portfolio leadership' },
      { name: 'Executive Communication', description: 'Regular communication with executive team on product strategy', scope: 'Company-wide product decisions' },
      { name: 'Market and Competitive Intelligence', description: 'Lead market analysis and competitive positioning', impact: 'Strategic business decisions' }
    ],
    tools: [
      { name: 'Strategic Planning Platforms', purpose: 'Long-term strategic planning', role: 'Strategic planning lead' },
      { name: 'Executive Dashboards', purpose: 'Executive reporting and KPI tracking', access: 'Dashboard creation and management' },
      { name: 'Market Intelligence Tools', purpose: 'Competitive analysis and market research', role: 'Market intelligence lead' }
    ],
    processes: [
      { name: 'Portfolio Management', steps: ['Assess product portfolio', 'Define investment priorities', 'Allocate resources', 'Monitor performance'] },
      { name: 'Innovation Planning', steps: ['Identify innovation opportunities', 'Evaluate new technologies', 'Plan innovation initiatives', 'Drive execution'] }
    ]
  }
};
